/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
/**
 * Create error action
 * @param {[type]} error {title: String, subtitle: String}
 */
export const addError = error => ({ type: ADD_ERROR, error });

export const clearError = error => ({ type: CLEAR_ERROR, error });
